<template>
  <div
    class="fixed bottom-0 left-0 w-full bg-white shadow-top z-50 flex justify-around items-center h-16 border-t border-gray-200"
  >
    <router-link
      :to="{ name: 'Home' }"
      class="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-blue-600 transition duration-200"
      active-class="text-blue-600"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mb-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
      <span class="text-xs font-medium">Transaksi</span>
    </router-link>

    <router-link
      :to="{ name: 'Loan' }"
      class="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-blue-600 transition duration-200"
      active-class="text-blue-600"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mb-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
      <span class="text-xs font-medium">Bon Vendor</span>
    </router-link>

    <router-link
      :to="{ name: 'Salary' }"
      class="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-blue-600 transition duration-200"
      active-class="text-blue-600"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mb-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span class="text-xs font-medium">Gaji & Bon</span>
    </router-link>

    <router-link
      :to="{ name: 'JobSheet' }"
      class="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-blue-600 transition duration-200"
      active-class="text-blue-600"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mb-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"
        />
      </svg>
      <span class="text-xs font-medium">Job Sheet</span>
    </router-link>

    <router-link
      :to="{ name: 'UpahPasang' }"
      class="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-blue-600 transition duration-200"
      active-class="text-blue-600"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mb-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span class="text-xs font-medium">Upah Pasang</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'BottomNav'
}
</script>

<style scoped>
.shadow-top {
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.1), 0 -1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
